import styled from "styled-components";
import { Color, Font, breakpoints,ColorDark} from "@/shared/Constants";

export const ContainerServices = styled.section `
  font-family: ${Font.serifRegular};
  color: ${Color.black};
  display: flex;
  flex-direction: row;
  margin-bottom: 60px;
  column-gap: 1rem;
  justify-content: center;
  width: 100%;
  ${breakpoints.darkMode} {
    [data-theme='dark'] & {
    color: ${ColorDark.textLight};
    }
  }
 /* ${breakpoints.tablet} {
    max-width: 975px;
    column-gap: 0;
  }*/
  ${breakpoints.phone} {
    flex-direction: column;
  }

  .banners {
    min-width: 300px;
    margin-top: 14px;
  }
  #rootGames .menu-ppal {
    display:none;
  }
  /* #rootGames .em-border-disabled-lighter {
    border-color: transparent !important;
  } Comentó esta linea porque hace que desaparezca la grilla de palabras*/ 
`;

export const ServicesData = styled.div `
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.widthFull ? "100%" : "calc(100% - 300px)")};
  border-right: ${(props) => (props.widthFull ? "none" : `1px solid ${Color.greySeparator}`)};;
  ${props => !props.widthFull ? "padding-right: 13px;" : ""}
  ${props => props.enabledHeader ? "margin-top: 15px;" : ""}  
  /* ${breakpoints.phoneTablet} {
    width: 100%;    
  } */

  ${breakpoints.phone} {
    width: 100%;
    flex-wrap: wrap;
    border-right: none;
    padding-right: 0;
  
  }
`;